import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {
    BestellungExtern,
    BestellungExternApi,
    BestellungExternDokument,
    BestellungExternDokumentApi,
} from './bestellung-extern';
import { Observable } from 'rxjs';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';

@Injectable({ providedIn: 'root' })
export class BestellungExternService {
    constructor(
        private readonly http: HttpClient,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
    ) {}

    updateBestellungExtern(bestellungExtern: BestellungExtern): Observable<BestellungExtern> {
        return this.http.post<BestellungExtern>(this.apiBaseUrl + 'bestellung_extern/update.php', bestellungExtern);
    }

    getDeliveryNotes(bestellungExtern: BestellungExtern): Observable<BestellungExternDokumentApi> {
        return this.http.get<BestellungExternDokumentApi>(
            this.apiBaseUrl +
                'bestellung_extern_dokument/read_lieferschein.php?bestellung_extern_id=' +
                bestellungExtern.bestellung_extern_id,
        );
    }

    getInvoices(bestellungExtern: BestellungExtern): Observable<BestellungExternDokumentApi> {
        return this.http.get<BestellungExternDokumentApi>(
            this.apiBaseUrl +
                'bestellung_extern_dokument/read_rechnung.php?bestellung_extern_id=' +
                bestellungExtern.bestellung_extern_id,
        );
    }

    deleteBestellungExternDokument(bestellExternDokument: BestellungExternDokument) {
        return this.http.post(this.apiBaseUrl + 'bestellung_extern_dokument/delete.php', bestellExternDokument);
    }

    getBestellungenByMaterialAndStatus(materialId: number, status?: number[]): Observable<BestellungExternApi> {
        let params = new HttpParams();
        params = params.append('artikel_id', materialId.toString());
        if (status != undefined && status.length > 0) {
            for (const s of status) {
                params = params.append('status_id[]', s.toString());
            }
        }
        return this.http.get<BestellungExternApi>(this.apiBaseUrl + 'artikel_bestellung_extern/read.php', {
            params: params,
        });
    }
}
